/** Window flags that block list modules from refetching after client-side navigation. */
const MODULE_SESSION_FLAGS = [
  '__ordersDataFetched',
  '__ordersDeletedCountFetched',
  '__employeeFiltersDataFetched',
  '__employeeDataFetched',
  '__usersDataFetched',
  '__rolesDataFetched',
  '__customersDeletedCountFetched',
  '__suppliersDeletedCountFetched',
  '__transactionsDataFetched',
  '__orderProgressCompaniesDataFetched',
] as const;

export function resetModuleSessionFlags(): void {
  const win = window as typeof window & Record<string, unknown>;
  MODULE_SESSION_FLAGS.forEach((flag) => {
    win[flag] = false;
  });
}
